// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#60a5fa',  // blue-400 (lighter)
      dark: '#1e3a8a',  // blue-900
      light: '#93c5fd', // blue-300
    },
    secondary: {
      main: '#818cf8',  // indigo-400 (lighter)
      dark: '#3730a3',  // indigo-800
      light: '#a5b4fc', // indigo-300
    },
    background: {
  default: 'rgba(0,0,0,0)', // allow gradient from index.css to show (valid color)
      paper: 'rgba(22, 27, 40, 0.76)', // slightly lighter/translucent
    },
    text: {
      primary: '#dbe5f3',
      secondary: '#aab6c8',
    },
    divider: 'rgba(148, 163, 184, 0.16)',
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Arial, -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", sans-serif',
    allVariants: {
      color: '#e6edf6',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.3s, color 0.3s, box-shadow 0.2s',
          fontWeight: 400,
          textTransform: 'uppercase',
          fontSize: '0.95rem',
          letterSpacing: '0.03em',
        },
        containedPrimary: {
          backgroundColor: '#1d4ed8', // darker blue for readability
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#1e40af',
          },
          '&:active': {
            backgroundColor: '#1e3a8a',
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(29,78,216,0.4)',
            color: 'rgba(255,255,255,0.7)'
          }
        },
        outlinedPrimary: {
          borderColor: 'rgba(96,165,250,0.6)',
          color: '#e6edf6',
          '&:hover': {
            borderColor: 'rgba(96,165,250,0.9)',
            backgroundColor: 'rgba(96,165,250,0.12)'
          }
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.active': {
            backgroundColor: 'rgba(96,165,250,0.22)',
            color: '#e6edf6',
            '& .MuiListItemIcon-root': {
              color: '#e6edf6',
            },
          },
          color: '#e6edf6',
          '&:hover': {
            backgroundColor: 'rgba(96,165,250,0.14)',
          },
          transition: 'background-color 0.3s, color 0.3s',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(148,163,184,0.16)'
        },
      },
    },
  },
});

export default theme;
